import PropTypes from "prop-types";
import dayjs from 'dayjs';

function DateFormat(props) {
	const { showOnlyDate } = props;

	const date = dayjs(props.children);
	const formattedDate = date.isValid() ? date.format(showOnlyDate ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm') : '-';

	return formattedDate;
  }

DateFormat.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	])
}

export default DateFormat;
